<template>
    <ButtonComponent 
        :content="value" 
        :icon="null"
        :link="null"
        type="3"
        :isSubmit="true"
        :fullWidth="true"
        :disabled="disabled"
        />
</template>

<script>
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue'

export default {
    props: ['value', 'disabled'],
    components: {ButtonComponent},
    setup(props){

        return{
            
        }
    }
}
</script>

<style>

</style>
